module.exports = __webpack_public_path__ + "img/article_5_1.94d696be.png";